import { DossierSectionId } from '../../constants/bankDossier';

/**
 * The strip and the sections live in different parts of a page and know
 * nothing about each other; a DOM event lets the strip ask a section to open.
 */
export const OPEN_DOSSIER_SECTION_EVENT = 'bank-dossier:open-section';

export const dossierSectionDomId = (id: DossierSectionId): string =>
  `bank-dossier-${id}`;

export const requestOpenDossierSection = (id: DossierSectionId): void => {
  window.dispatchEvent(
    new CustomEvent<DossierSectionId>(OPEN_DOSSIER_SECTION_EVENT, {
      detail: id,
    })
  );
};
